// URL: https://observablehq.com/@jianan-li/kickstarter-time-series-analysis-part-1
// Title: Kickstarter Time Series Analysis (Part 1) 
// Author: Jianan Li (@jianan-li)
// Version: 381
// Runtime version: 1
/* eslint-disable */
const m0 = {
  id: "488424c7dba81b66@381",
  variables: [
    {
      inputs: ["md"],
      value: (function(md){return(
md`# Kickstarter Time Series Analysis (Part 1) <br/><br/>`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md`[Part 2 →](/@jianan-li/kickstarter-time-series-analysis-part-2)<br>
[Colab Notebook →](https://colab.research.google.com/drive/1DAsNmW9fi0t26z0mkQDRTtl_SZNpwDNn)<br>
[Data Source →](https://www.kaggle.com/kemical/kickstarter-projects)<br><br>
`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `### The Ambitious Project Creators<br/>`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `How has the distribution of project funding goal changed since the beginning of Kickstarter? <br/><br/>`
)})
    },
    {
      inputs: ["md"],
      value: (function(md){return(
md `Note: it takes a few seconds for the graph to load both upon initial page load and when switching between the two view options due to downloading and rendering the large amount of data (~372,000 entries).<br/><br/>`
)})
    },
    {
      name: "viewof yAxisZoom",
      inputs: ["radio"],
      value: (function(radio){return(
radio({
  title: 'I want to ...',
  description: '',
  options: [
    { label: 'get a sense of the distribution of the majority of Kickstarter projects', value: "0" },
    { label: 'see the most ambitious Kickstarter projects ever launched (for shits and giggles)', value: "1" },
  ],
  value: "0"
})
)})
    },
    {
      name: "yAxisZoom",
      inputs: ["Generators","viewof yAxisZoom"],
      value: (G, _) => G.input(_)
    },
    {
      name: "chart",
      inputs: ["d3","DOM","width","height","t","margin","yAxis","xAxis","data","boxplot","x"],
      value: (function(d3,DOM,width,height,t,margin,yAxis,xAxis,data,boxplot,x)
{
  const svg = d3.select(DOM.svg(width, height));
    
  svg.append('g')
    .attr('class', 'y-axis')
    .interrupt()
    .transition(t)
    .attr("transform", `translate(${ margin.left },0)`)
    .call(yAxis);
  
  svg.append('g')
    .attr('class', 'x-axis-label')
    .attr("transform", `translate(${ width  - margin.right },${ height - 10 })`)
    .append('text')
    .attr("text-anchor", "end")
  
  svg.append('g')
    .attr('class', 'y-axis-label')
    .attr("transform", `rotate(-90) translate(-5,30)`)
    .append('text')
    .attr("text-anchor", "end")
    .text('Project Funding Goal (USD)');
  
  svg.append('g')
    .attr('class', 'x-axis')
    .attr("transform", `translate(0,${ height - margin.bottom })`)
    .call(xAxis)
    .selectAll('text')
    .attr("transform", "translate(0,20)")
  
  svg.select(".x-axis").selectAll(".tick").selectAll("text")
    .attr("fill","hsl(0, 0%, 50%)")
    .style("font-size","1rem")
  
  svg.select(".y-axis").selectAll(".tick").selectAll("text")
    .attr("fill","hsl(0, 0%, 50%)")
    .style("font-size","0.8rem")
  
  svg.select(".y-axis-label").select("text")
    .attr("fill","hsl(0, 0%, 30%)")
    .style("font-size","1.2rem")

  let selection = svg.append('g').attr('class', 'boxplots').selectAll('.boxplot').data(data);
  
  selection.exit().remove();
  
  selection.call(boxplot);
  
  selection.enter()
    .append("g")
    .attr("class", "boxplot")
    .attr("transform", (d) => `translate(${ x(d.group) }, 0)`)
    .attr("data-season", (d) => d.group)
    .call(boxplot);
  
  return svg.node();
}
)
    },
    {
      name: "data",
      inputs: ["histogram"],
      value: (async function(histogram){return(
(await fetch(`https://raw.githubusercontent.com/Jianan-Li/Kickstarter-Time-Series-Analysis/master/df_1.json`)).json().then((json) => json.map(histogram))
)})
    },
    {
      name: "boxplot",
      inputs: ["bandwidth","y","quartileTooltip","onMouseOverQuartile","onMouseMoveQuartile","onMouseOutQuartile","offsets","title","onMouseOverOutlier","onMouseMoveOutlier","onMouseOutOutlier"],
      value: (function(bandwidth,y,quartileTooltip,onMouseOverQuartile,onMouseMoveQuartile,onMouseOutQuartile,offsets,title,onMouseOverOutlier,onMouseMoveOutlier,onMouseOutOutlier){return(
(g) => {
  
  g.append("line")
    .attr("class", "guide")
    .attr("x1", bandwidth / 2)
    .attr("y1", (d) => y(d.min))
    .attr("x2", bandwidth / 2)
    .attr("y2", (d) => y(d.max))
    .attr("stroke", "steelblue");
  
  g.append("line")
    .attr("class", "whisker")
    .attr("x1", bandwidth / 2)
    .attr("y1", (d) => y(d.range[1]))
    .attr("x2", bandwidth / 2)
    .attr("y2", (d) => y(d.range[0]))
    .attr("stroke", "green");

  g.append("line")
    .attr("class", "range-bot")
    .attr("x1", 0)
    .attr("y1", (d) => y(d.range[0]))
    .attr("x2", bandwidth)
    .attr("y2", (d) => y(d.range[0]))
    .attr("stroke", "steelblue");

  g.append("line")
    .attr("class", "range-bot")
    .attr("x1", 0)
    .attr("y1", (d) => y(d.range[1]))
    .attr("x2", bandwidth)
    .attr("y2", (d) => y(d.range[1]))
    .attr("stroke", "steelblue");

  g.append("path")
    .attr("class", "quartile")
    .attr("d", (d) => `M0,${ y(d.quartiles[2]) }h${ bandwidth }V${ y(d.quartiles[0]) }H0Z`)
    .attr("data-tooltip", (d) => quartileTooltip(d))
    .attr("data-pid", (d) => d.pid)
    .on("mouseover", onMouseOverQuartile)
    .on("mousemove", onMouseMoveQuartile)
    .on("mouseout", onMouseOutQuartile);
  
  g.append("line")
    .attr("class", "median")
    .attr("x1", 0)
    .attr("y1", (d) => y(d.quartiles[1]))
    .attr("x2", bandwidth)
    .attr("y2", (d) => y(d.quartiles[1]));

  g.selectAll('.outlier')
    .data(d => d.outliers)
    .enter()
    .append('circle')
    .attr('class', 'outlier')
    .attr('r', 3)
    .attr('cx', (d, i) => { 
      // alternate the x position of each
      // outlier so they overlap less
      return (bandwidth/2) + offsets[i%6];                        
    })
    .attr('cy', (d) => y(d['usd_goal_real']))
    .attr("data-tooltip", (d) => title(d))
    .attr("data-pid", (d) => d['ID'])
    .on("mouseover", onMouseOverOutlier)
    .on("mousemove", onMouseMoveOutlier)
    .on("mouseout", onMouseOutOutlier);
  
}
)})
    },
    {
      name: "offsets",
      value: (function(){return(
[-15,-9,-3,3,9,15]
)})
    },
    {
      name: "onMouseOutQuartile",
      inputs: ["tooltip"],
      value: (function(tooltip){return(
function onMouseOutQuartile (d) {
  tooltip.text("");
  // d3.selectAll(`circle.outlier[data-pid="${ d.pid }"]`).classed('active', false);
  return tooltip.style("visibility", "hidden");
}
)})
    },
    {
      name: "onMouseMoveQuartile",
      inputs: ["tooltip","d3"],
      value: (function(tooltip,d3){return(
function onMouseMoveQuartile (d) {
  return tooltip.style("top", (d3.event.pageY+20)+"px").style("left",(d3.event.pageX+10)+"px");
}
)})
    },
    {
      name: "onMouseOverQuartile",
      inputs: ["tooltip"],
      value: (function(tooltip){return(
function onMouseOverQuartile (d) {
  tooltip.text(this.dataset.tooltip);
  // d3.selectAll(`circle.outlier[data-pid="${ d.pid }"]`).classed('active', true);
  return tooltip.style("visibility", "visible");
}
)})
    },
    {
      name: "onMouseOutOutlier",
      inputs: ["tooltip","d3"],
      value: (function(tooltip,d3){return(
function onMouseOutOutlier (d) {
  tooltip.text("");
  d3.selectAll(`circle.outlier[data-pid="${ d['ID'] }"]`).classed('active', false);
  return tooltip.style("visibility", "hidden");
}
)})
    },
    {
      name: "onMouseMoveOutlier",
      inputs: ["tooltip","d3"],
      value: (function(tooltip,d3){return(
function onMouseMoveOutlier (d) {
  return tooltip.style("top", (d3.event.pageY+20)+"px").style("left",(d3.event.pageX+10)+"px");
}
)})
    },
    {
      name: "onMouseOverOutlier",
      inputs: ["tooltip","d3"],
      value: (function(tooltip,d3){return(
function onMouseOverOutlier (d) {
  tooltip.text(this.dataset.tooltip);
  d3.selectAll(`circle.outlier[data-pid="${ d['ID'] }"]`).classed('active', true);
  return tooltip.style("visibility", "visible");
}
)})
    },
    {
      name: "tooltip",
      inputs: ["d3"],
      value: (function(d3){return(
d3.select("body").append("div")
  .attr("class", "svg-tooltip")
  .text("")
)})
    },
    {
      name: "bandwidth",
      inputs: ["x"],
      value: (function(x){return(
x.bandwidth()
)})
    },
    {
      name: "t",
      inputs: ["d3"],
      value: (function(d3){return(
d3.transition().duration(250)
)})
    },
    {
      name: "x",
      inputs: ["d3","margin","width","data"],
      value: (function(d3,margin,width,data){return(
d3.scaleBand()
  .range([margin.left, width - margin.right])
  .padding(0.3)
  .domain(data.map((s) => s.group))
)})
    },
    {
      name: "y",
      inputs: ["d3","height","margin","yAxisZoom","data"],
      value: (function(d3,height,margin,yAxisZoom,data){return(
d3.scaleLinear()
      .range([height - margin.bottom, margin.top])
      .domain([0, (yAxisZoom === '0' ? 50000 : d3.max(data, (d) => d.max))]).nice()
)})
    },
    {
      name: "xAxis",
      inputs: ["d3","x"],
      value: (function(d3,x){return(
d3.axisBottom(x).tickSize(0)
)})
    },
    {
      name: "yAxis",
      inputs: ["d3","y","width","margin"],
      value: (function(d3,y,width,margin){return(
d3.axisLeft(y).tickSize(-width+margin.left+margin.right).tickFormat((d) =>  "$" + d3.format(",")(d)  )
)})
    },
    {
      name: "quartileTooltip",
      inputs: ["d3"],
      value: (function(d3){return(
(d) => 
`Max: $${ d3.format(",.0f")(d.range[1])}
Q3: $${ d3.format(",.0f")(d.quartiles[2]) }
Median: $${ d3.format(",.0f")(d.quartiles[1]) }
Q1: $${ d3.format(",.0f")(d.quartiles[0]) }
Min: $${ d3.format(",.0f")(d.range[0]) }
`
)})
    },
    {
      name: "title",
      inputs: ["numberWithCommas","capitalize"],
      value: (function(numberWithCommas,capitalize){return(
(d) => 
`${ d.name }
${ d.main_category } / ${ d.category }
${ (d.currency==='USD') ? 'US$ '+numberWithCommas(d.goal) : d.currency + ' ' + numberWithCommas(d.goal) + ' (US$ '+numberWithCommas(d['usd_goal_real'])+')' }
Launched on ${new Date(d.launched).getMonth()+'/'+new Date(d.launched).getDate()+'/'+new Date(d.launched).getFullYear()}
${ capitalize(d.state) }
`
)})
    },
    {
      name: "capitalize",
      value: (function(){return(
(s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
)})
    },
    {
      name: "histogram",
      inputs: ["d3"],
      value: (function(d3){return(
function histogram (year) {
  
  // sort players by points asc
  let projects = year.projects.sort((a,b) => a['usd_goal_real'] - b['usd_goal_real']);

  // map points to an array
  let stat = projects.map((sk) => sk['usd_goal_real']);

  // get the min and max
  let min = stat[0];
  let max = stat[stat.length-1];
  
  // quantiles
  let q1 = d3.quantile(stat, 0.25);
  let q2 = d3.quantile(stat, 0.50);
  let q3 = d3.quantile(stat, 0.75);

  // interquartile range
  let iqr = q3 - q1; 
  
  // range
  let r0 = Math.max(min, q1 - iqr * 1.50);
  let r1 = Math.min(max, q3 + iqr * 1.50);
  
  let group = {
    group: year.launch_year,
    projects,
    min,
    max,
    quartiles: [q1,q2,q3],
    range: [r0,r1],
    iqr,
    outliers: projects.filter(sk => sk['usd_goal_real'] > r1)
  }
  
  return group;
}
)})
    },
    {
      inputs: ["width"],
      value: (function(width){return(
width
)})
    },
    {
      name: "height",
      inputs: ["width"],
      value: (function(width){return(
width * 0.55
)})
    },
    {
      name: "margin",
      value: (function(){return(
{ top:20, right:80, bottom:100, left:120 }
)})
    },
    {
      name: "graphWidth",
      inputs: ["width","margin"],
      value: (function(width,margin){return(
width - margin.left - margin.right
)})
    },
    {
      name: "graphHeight",
      inputs: ["height","margin"],
      value: (function(height,margin){return(
height - margin.top - margin.bottom
)})
    },
    {
      name: "numberWithCommas",
      value: (function(){return(
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
)})
    },
    {
      inputs: ["$"],
      value: (function($){return(
$( "*" ).css( "font-family", "-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif" )
)})
    },
    {
      name: "$",
      inputs: ["require"],
      value: (function(require){return(
require("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js")
)})
    },
    {
      from: "@jashkenas/inputs",
      name: "slider",
      remote: "slider"
    },
    {
      from: "@jashkenas/inputs",
      name: "radio",
      remote: "radio"
    },
    {
      from: "@jashkenas/inputs",
      name: "button",
      remote: "button"
    },
    {
      name: "d3",
      inputs: ["require"],
      value: (function(require){return(
require("d3@5")
)})
    },
    {
      name: "styles",
      inputs: ["html"],
      value: (function(html){return(
html`
  <style>
  .domain {
    visibility: hidden;
  }

  .whisker {
    stroke: #024752;
    stroke-width: 1px;
  }

  .range-top,
  .range-bot {
    stroke: #024752;
    stroke-width: 1px;
  }

  .guide {
    visibility: hidden;
    stroke: #bababa;
    stroke-dasharray: 1 2;
  }

  .quartile {
    fill: #0395AB;
    stroke: #0395AB;
    fill-opacity: 1;
    stroke-width: 0px;
  }

  .median {
    stroke: #ffffff;
    stroke-width: 2px;
  }

  .outlier {
    fill: #dadada;
    stroke: #c8c8c8;
    cursor: pointer;
  }

  .outlier.active {
    fill: #0395AB;
    stroke: #0395AB;
  }
  
  .y-axis-label,
  .x-axis-label {
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple       Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 12px;
    text-transform: uppercase;
  }

  .y-axis line {
    stroke-dasharray: 2 2;
    stroke: #bababa;
  }

  .y-axis .domain {
    fill-opacity: 0;
    stroke-opacity: 0;    
  }

  .svg-tooltip {
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple   Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    background: rgba(69,77,93,.9);
    border-radius: .1rem;
    color: #fff;
    display: block;
    font-size: 11px;
    max-width: 500px;
    padding: .2rem .4rem;
    position: absolute;
    text-overflow: ellipsis;
    white-space: pre;
    z-index: 300;
    visibility: hidden;
  }
</style>`
)})
    }
  ]
};

const m1 = {
  id: "@jashkenas/inputs",
  variables: [
    {
      name: "slider",
      inputs: ["input"],
      value: (function(input){return(
function slider(config = {}) {
  let {value, min = 0, max = 1, step = "any", precision = 2, title, description, getValue, format, display, submit} = config;
  if (typeof config == "number") value = config;
  if (value == null) value = (max + min) / 2;
  precision = Math.pow(10, precision);
  if (!getValue) getValue = input => Math.round(input.valueAsNumber * precision) / precision;
  return input({
    type: "range", title, description, submit, format, display,
    attributes: {min, max, step, value},
    getValue
  });
}
)})
    },
    {
      name: "radio",
      inputs: ["input","html"],
      value: (function(input,html){return(
function radio(config = {}) {
  let { value: formValue, title, description, submit, options } = config;
  if (Array.isArray(config)) options = config;
  options = options.map(
    o => (typeof o === "string" ? { value: o, label: o } : o)
  );
  const form = input({
    type: "radio",
    title,
    description,
    submit,
    getValue: input => {
      const checked = Array.prototype.find.call(input, radio => radio.checked);
      return checked ? checked.value : undefined;
    },
    form: html`
      <form>
        ${options.map(({ value, label }) => {
          const input = html`<input type=radio name=input ${
            value === formValue ? "checked" : ""
          } style="vertical-align: baseline;" />`;
          input.setAttribute("value", value);
          const tag = html`
          <label style="display: inline-block; margin: 5px 10px 3px 0; font-size: 0.85em;">
           ${input}
           ${label}
          </label>`;
          return tag;
        })}
      </form>
    `
  });
  form.output.remove();
  return form;
}
)})
    },
    {
      name: "button",
      inputs: ["input"],
      value: (function(input){return(
function button(config = {}) {
  let {value, title, description, disabled} = config;
  if (typeof config == "string") value = config;
  if (!value) value = "Ok";
  const form = input({
    type: "button", title, description,
    attributes: {disabled, value}
  });
  form.output.remove();
  return form;
}
)})
    },
    {
      name: "input",
      inputs: ["html","d3format"],
      value: (function(html,d3format){return(
function input(config) {
  let {
    form,
    type = "text",
    attributes = {},
    action,
    getValue,
    title,
    description,
    format,
    display,
    submit,
    options
  } = config;
  const wrapper = html`<div></div>`;
  if (!form)
    form = html`<form>
	<input name=input type=${type} />
  </form>`;
  Object.keys(attributes).forEach(key => {
    const val = attributes[key];
    if (val != null) form.input.setAttribute(key, val);
  });
  if (submit)
    form.append(
      html`<input name=submit type=submit style="margin: 0 0.75em" value="${
        typeof submit == "string" ? submit : "Submit"
      }" />`
    );
  form.append(
    html`<output name=output style="font: 14px Menlo, Consolas, monospace; margin-left: 0.5em;"></output>`
  );
  if (title)
    form.prepend(
      html`<div style="font: 700 0.9rem sans-serif;">${title}</div>`
    );
  if (description)
    form.append(
      html`<div style="font-size: 0.85rem; font-style: italic;">${description}</div>`
    );
  if (format) format = typeof format === "function" ? format : d3format.format(format);
  if (action) {
    action(form);
  } else {
    const verb = submit
      ? "onsubmit"
      : type == "button"
      ? "onclick"
      : type == "checkbox" || type == "radio"
      ? "onchange"
      : "oninput";
    form[verb] = e => {
      e && e.preventDefault();
      const value = getValue ? getValue(form.input) : form.input.value;
      if (form.output) {
        const out = display ? display(value) : format ? format(value) : value;
        if (out instanceof window.Element) {
          while (form.output.hasChildNodes()) {
            form.output.removeChild(form.output.lastChild);
          }
          form.output.append(out);
        } else {
          form.output.value = out;
        }
      }
      form.value = value;
      if (verb !== "oninput")
        form.dispatchEvent(new CustomEvent("input", { bubbles: true }));
    };
    if (verb !== "oninput")
      wrapper.oninput = e => e && e.stopPropagation() && e.preventDefault();
    if (verb !== "onsubmit") form.onsubmit = e => e && e.preventDefault();
    form[verb]();
  }
  while (form.childNodes.length) {
    wrapper.appendChild(form.childNodes[0]);
  }
  form.append(wrapper);
  return form;
}
)})
    },
    {
      name: "d3format",
      inputs: ["require"],
      value: (function(require){return(
require("d3-format@1")
)})
    }
  ]
};

const notebook = {
  id: "488424c7dba81b66@381",
  modules: [m0,m1]
};

export default notebook;
